const DocQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 60
    },
    {
        name: 'HBI No',
        code: 'hbiNo',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'BL',
        code: 'blNo',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'InvoiceNo',
        code: 'invoiceNo',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'Container No',
        code: 'containerNo',
        column: true,
        defaultFilter: true,
        listFilter: true,
        sortable: true,
        width: 120
    },
    {
        name: 'Seal no',
        code: 'sealNo',
        column: true,
        sortable: true,
        align: 'left',
        width: 100
    },
    {
        name: 'Scaned Cartons',
        code: 'fnCount',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    },
    {
        name: 'Unscan',
        code: 'opCount',
        column: true,
        sortable: true,
        align: 'center',
        width: 100
    },
    {
        name: 'Pieces',
        code: 'totalPieces',
        column: true,
        sortable: true,
        align: 'center',
        width: 100
    },
    {
        name: 'Status',
        code: 'status',
        column: true,
        sortable: true,
        align: 'center',
        width: 120
    }
];



export default DocQueryFields;
